import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {TreatmentModel} from '../model/treatment.model';
import {FormConverter} from '../../../../../form/form/api/entity/converter/form.converter';
import {
    ConsultationSummaryConverter
} from '../../../../consultation/consultation/api/model/converter/consultationSummary.converter';

@Injectable({providedIn: 'root'})
export class TreatmentConverter extends HttpModelConverter<TreatmentModel> {

    constructor(private formConverter: FormConverter,
                private consultationSummaryConverter: ConsultationSummaryConverter) {
        super();
    }

    protected createInstance(): TreatmentModel {
        return new TreatmentModel();
    }

    protected enrichObject(result: TreatmentModel, src: TreatmentModel) {
        result.form = this.formConverter.convert(src.form);
        result.consultation = this.consultationSummaryConverter.convert(src.consultation);
    }
}
